// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { ACTION, setLoading, wrap } from './index';
import { Dispatch } from 'redux';
import {
  SchemaGetBasketContentQueryParams,
  SchemaGetCheckBasketStateQueryParams,
  SchemaGetGeoInformationQueryParams,
  SchemaLocationItem,
  SchemaPatchBasketDefinitionRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const getBasketContent = (params: SchemaGetBasketContentQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      if (params.basketreference === null) {
        delete params.basketreference;
      }

      const { data, error } = await legacyApi.GET('/basketcontent', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_BASKET,
        payload: { ...data, basket: params.basket },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const getUserInfo = () =>
  wrap(async (dispatch: Dispatch) => {
    dispatch(
      setLoading({
        value: true,
        name: 'userinfo',
      }),
    );
    try {
      const { data, error } = await legacyApi.GET('/userinfo');

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_USER_INFO, payload: data });

      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'userinfo',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'userinfo',
        }),
      );
    }
  }, constants.FETCH_ERROR);

// API: Unused route, legacy code:
export const possibleFormats = (payload: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'possibleformats',
        }),
      );

      // @ts-expect-error not typed:
      const { data, error } = await legacyApi.POST('/possibleformats', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.POSSIBLE_FORMATS, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'possibleformats',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'possibleformats',
        }),
      );
    }
  }, 'POST_ERROR');

// API: Unused route, legacy code:
export const selectOrDeselect = (payload: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error not on OpenAPI Spec.
      const { data, error } = await legacyApi.POST('/deselectentry', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.BASKET_SELECTION_UPDATED,
        payload: {
          // @ts-expect-error not on OpenAPI Spec.s
          ...data,
          basket: payload.basket,
          productIds: payload.entries,
          state: payload.state,
        },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

// Unused Action with unknown payload
export const fetchBasketCustomer = (params: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error not typed on OpenAPI spec:
      const { data, error } = await legacyApi.GET('/basketcustomer', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_BASKET_CUSTOMER,
        payload: data,
      });

      // @ts-expect-error not typed on OpenAPI spec:
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

// API: Unused route, legacy code:
export const postGenerateProposals = (payload: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error Does not exist on OpenApi Spec.
      const { data, error } = await legacyApi.POST('/proposals', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_PROPOSALS, payload: data });
      // @ts-expect-error Does not exist on OpenApi Spec.
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

// Unused Action with unknown payload type:
export const postForBudgets = (payload: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error not typed on OpenAPI Spec:
      const { data, error } = await legacyApi.POST('/possiblebudgets', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_BUDGETS, payload: data });

      // @ts-expect-error not typed on OpenAPI Spec:
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const getBasketState = (params: SchemaGetCheckBasketStateQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/checkstate', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_BASKET_STATE,
        payload: { ...data },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const patchBasketDefinition = (payload: SchemaPatchBasketDefinitionRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.PATCH('/basketdefinition', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const fetchLocationPolygonalByUrn = (params: SchemaGetGeoInformationQueryParams & { address: string }) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ name: 'map', value: true }));

      const { data, error } = await legacyApi.GET('/geoinformation', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCH_LOCATION_POLYGONAL_BORDER,
        payload: {
          address: params.address,
          data: data.data.length ? data.data[0] : null,
        },
      });

      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading({ name: 'map', value: false }));

      throw err;
    } finally {
      dispatch(setLoading({ name: 'map', value: false }));
    }
  }, constants.FETCH_ERROR);

export const toggleRadius = () => ({ type: constants.TOGGLE_DRAW_RADIUS });

export const updateBudget = (payload: string): ACTION => ({
  type: constants.UPDATE_BUDGET,
  payload,
});
export const updateDigital = (payload: number): ACTION => ({
  type: constants.UPDATE_DIGITAL,
  payload,
});
export const updateDateAccuracy = (payload: string): ACTION => ({
  type: constants.UPDATE_DATE_ACCURACY,
  payload,
});
export const updateCityLocation = (payload: SchemaLocationItem): ACTION => ({
  type: constants.UPDATE_CITY_LOCATION,
  payload,
});
export const step1Save = (payload: any): ACTION => ({
  type: constants.STEP1_SAVE,
  payload,
});

export const addLocation = (payload: SchemaLocationItem): ACTION => ({
  type: constants.ADD_LOCATION,
  payload,
});
export const updateLocation = (payload: SchemaLocationItem): ACTION => ({
  type: constants.UPDATE_LOCATION,
  payload,
});

export const removeLocation = (payload: string): ACTION => ({
  type: constants.REMOVE_LOCATION,
  payload,
});
export const setChosenProposal = (payload: any): ACTION => ({
  type: constants.SET_CHOSEN_PROPOSAL,
  payload,
});

export const setFilters = (payload: any) => {
  return function (dispatch: Dispatch) {
    dispatch({ type: constants.SET_FILTERS, payload });
  };
};

export const updateAttributes = (payload: any): ACTION => ({
  type: constants.UPDATE_ATTRIBUTES1,
  payload,
});
